module.exports = __webpack_public_path__ + "static/media/aragon79.1cf222a7.jpg";